// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as PartnerStatus from "../entity/PartnerStatus.bs.js";
import * as PartnerLoginStatus from "../entity/PartnerLoginStatus.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as FilterPartnerResponse from "../../filter-partners/entity/FilterPartnerResponse.bs.js";
import * as PartnerOnboardingData from "../entity/PartnerOnboardingData.bs.js";
import * as PartnerDocumentApiModel from "../api-modal/PartnerDocumentApiModel.bs.js";
import * as PartnerWaitlistDataApiModel from "../api-modal/PartnerWaitlistDataApiModel.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function decodeDriverLocation(json) {
  return {
          lat: Json_decode.field("lat", Json_decode.string, json),
          lng: Json_decode.field("lng", Json_decode.string, json)
        };
}

function decodeHelperServiceability(json) {
  return {
          feature_enabled: Json_decode.field("feature_enabled", Json_decode.bool, json),
          is_active: Json_decode.field("is_active", (function (param) {
                  return Json_decode.optional(Json_decode.bool, param);
                }), json)
        };
}

function decodeRentalSeviceability(json) {
  return {
          feature_enabled: Json_decode.field("feature_enabled", Json_decode.bool, json),
          is_active: Json_decode.field("is_serving", (function (param) {
                  return Json_decode.optional(Json_decode.bool, param);
                }), json)
        };
}

function decodeOutStationServiceability(json) {
  return {
          feature_enabled: Json_decode.field("feature_enabled", Json_decode.bool, json),
          is_active: Json_decode.field("is_serving", (function (param) {
                  return Json_decode.optional(Json_decode.bool, param);
                }), json)
        };
}

function driverProfileDecoder(json) {
  return {
          appVersion: Json_decode.field("app_version", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          clusterName: Json_decode.field("cluster_name", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          dateOfJoining: new Date(Json_decode.field("date_of_joining", Json_decode.string, json)),
          partnerStatus: PartnerStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          engagementType: Json_decode.field("engagement_type", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          geoRegion: Json_decode.field("geo_region", Json_decode.string, json),
          loginStatus: PartnerLoginStatus.fromString(Json_decode.field("login_status", Json_decode.string, json)),
          lastUpdatedLocation: Json_decode.field("current_location", (function (param) {
                  return Json_decode.optional(decodeDriverLocation, param);
                }), json),
          lastLocationUpdatedAt: Belt_Option.mapWithDefault(Json_decode.field("last_location_updated_at", (function (param) {
                      return Json_decode.optional(Json_decode.string, param);
                    }), json), undefined, (function (ts) {
                  if (FormValidationUtils$Catalyst.isFloatStringValid(ts)) {
                    return Caml_option.some(new Date(Caml_format.caml_float_of_string(ts) * 1000.0));
                  }
                  
                })),
          msisdn: Json_decode.field("msisdn", Json_decode.string, json),
          uuid: Json_decode.field("uuid", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json),
          primaryMobile: Json_decode.field("primary_mobile", Json_decode.string, json),
          partnerCategory: Json_decode.field("partner_category", Json_decode.string, json),
          secondaryMobile: Json_decode.field("secondary_mobile", Json_decode.string, json),
          actAsHelper: Json_decode.field("act_as_helper", decodeHelperServiceability, json),
          outStation: Json_decode.field("serving_outstation", decodeOutStationServiceability, json),
          helperLabour: Json_decode.field("helper_labour", decodeHelperServiceability, json),
          rental: Json_decode.field("serving_rental", decodeRentalSeviceability, json),
          is_premium: Json_decode.field("is_premium", Json_decode.bool, json),
          sprinklr_guidance: Json_decode.field("sprinklr_guidance", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function ownerDecoder(json) {
  return {
          ownerName: Json_decode.field("name", Json_decode.string, json),
          ownerMobile: Json_decode.field("mobile", Json_decode.string, json),
          vehicleDriver: Json_decode.field("mobile", Json_decode.string, json),
          pan: Json_decode.field("pan", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          bankName: Json_decode.field("bank_name", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          bankAccountNumber: Json_decode.field("bank_account_number", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          bankIfsc: Json_decode.field("bank_ifsc", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function vehicleDecoder(json) {
  return {
          vehicleType: Json_decode.field("vehicle_type", Json_decode.string, json),
          vehicleNumber: Json_decode.field("vehicle_number", Json_decode.string, json),
          serviceVehicleTypes: Json_decode.field("service_vehicle_types", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json),
          hasNep: Json_decode.field("has_nep", (function (param) {
                  return Json_decode.optional(Json_decode.bool, param);
                }), json),
          fuel_category: Json_decode.field("fuel_category", Json_decode.string, json)
        };
}

function blacklistInfoDecoder(json) {
  return {
          periodBegin: new Date(Json_decode.at({
                      hd: "period",
                      tl: {
                        hd: "start",
                        tl: /* [] */0
                      }
                    }, Json_decode.string)(json)),
          periodEnd: new Date(Json_decode.at({
                      hd: "period",
                      tl: {
                        hd: "end",
                        tl: /* [] */0
                      }
                    }, Json_decode.string)(json)),
          reason: Json_decode.at({
                  hd: "reason",
                  tl: /* [] */0
                }, Json_decode.string)(json)
        };
}

function brandingInfoDecoder(json) {
  return {
          brandingType: Json_decode.field("type", Json_decode.string, json),
          isApproved: Json_decode.field("is_approved", Json_decode.bool, json),
          initialBrandingDate: new Date(Json_decode.field("initial_branding_date", Json_decode.string, json)),
          blacklistInfo: Json_decode.optional((function (param) {
                  return Json_decode.field("blacklisting", blacklistInfoDecoder, param);
                }), json)
        };
}

function driverBuilder(driverInfoJson) {
  return {
          driverProfile: Json_decode.field("driver_info", driverProfileDecoder, driverInfoJson),
          owner: Json_decode.field("owner_info", ownerDecoder, driverInfoJson),
          vehicle: Json_decode.field("vehicle_info", vehicleDecoder, driverInfoJson),
          brandingInfo: Json_decode.optional((function (param) {
                  return Json_decode.field("branding_info", brandingInfoDecoder, param);
                }), driverInfoJson)
        };
}

function apiModelToState(model) {
  return List.map((function (e) {
                return {
                        name: e.document_type_name,
                        status: e.document_status
                      };
              }), model);
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PartnerDocumentApiModel.res_decode(json), "partnerDocumentEntityMapper.re"));
}

var PartnerDocuments = {
  apiModelToState: apiModelToState,
  execute: execute
};

function apiModelToState$1(model) {
  return {
          driver_uuid: model.onboardee_uuid
        };
}

function execute$1(json) {
  var model = DeccoUtils$Catalyst.resolveResult(PartnerWaitlistDataApiModel.t_decode(json), "DriverStateMapper.re");
  return {
          driver_uuid: model.onboardee_uuid
        };
}

var PartnerWaitlist = {
  apiModelToState: apiModelToState$1,
  execute: execute$1
};

function execute$2(json) {
  return DeccoUtils$Catalyst.resolveResult(PartnerOnboardingData.t_decode(json), "DriverStateMapper.re");
}

var PartnerOnboarding = {
  execute: execute$2
};

function execute$3(json) {
  return DeccoUtils$Catalyst.resolveResult(FilterPartnerResponse.t_decode(json), "FilterDriverResponseMapper");
}

var FilterDriverResponseMapper = {
  execute: execute$3
};

export {
  decodeDriverLocation ,
  decodeHelperServiceability ,
  decodeRentalSeviceability ,
  decodeOutStationServiceability ,
  driverProfileDecoder ,
  ownerDecoder ,
  vehicleDecoder ,
  blacklistInfoDecoder ,
  brandingInfoDecoder ,
  driverBuilder ,
  PartnerDocuments ,
  PartnerWaitlist ,
  PartnerOnboarding ,
  FilterDriverResponseMapper ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
